import './full-page-index.jsx';
import './full-page-single-article.jsx';
import './panel-index.jsx';
import './panel-call-us.jsx';
import './panel-contact-options.jsx';
import './panel-single-article.jsx';
import {watchMouseOrKeyboard} from '@egencia/uitk-react';
/**
 * This Presenter is for your app-wide stuff.
 * Delete this if you don't have code that needs to run on every page.
 */

EG.HelpCenter.Presenters.App = function() {
    'use strict';
    watchMouseOrKeyboard();
    //----- Initialize -----
    EG.HelpCenter.isPanel = window.parent === window;
    const isPanelPageNotInIframe = window.parent === window && window.location.pathname.includes('panel');
    if (isPanelPageNotInIframe) {
        let url = `/help-center${EG.bootstrapped.contentId ? `/article/${EG.bootstrapped.contentId }`: ''}`;
        window.location.replace(url);
    } else {
        const hiddenPanelContent = document.querySelector('body.panel');
        if (hiddenPanelContent) {
            hiddenPanelContent.classList.remove('hidden');
        } 
    }
};

EG.HelpCenter.Presenters.App();